// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_login_login_module_ts":"986afba44856c4cc","src_app_features_dashboard_dashboard_module_ts":"091cc18137ad50ae"}[chunkId] + ".js";
};